import logger from './logger';
import getEvents from './events';
import { applyMiddleware } from 'redux';
export default applyMiddleware(
  // logger
  // getEvents,
);